import React, { FC } from "react"
import Img from "gatsby-image/withIEPolyfill"
import { IGatsbyImageComponentProps } from "./models"
import "./GatsbyImage.scss"
import DangerouslySetInnerHtml from "gatsby-theme-gaviscon/src/components/common/DangerouslySetInnerHtml"
import useScreenRecognition from "gatsby-theme-gaviscon/src/hooks/useScreenRecognition"

const GatsbyImage: FC<IGatsbyImageComponentProps> = ({
  isLazyLoading = true,
  alt,
  className,
  objectFit,
  objectPosition,
  fluid,
  useFocalPoint,
  useDesktopImage,
  ...restProps
}) => {
  const padY = parseInt(fluid.focalPoint?.y || "50", 10)
  const padX = parseInt(fluid.focalPoint?.x || "50", 10)
  const svgRest: { [key: string]: any } = restProps
  const { isNotMobile } = useScreenRecognition()

  const imageToRender = useDesktopImage
    ? fluid?.gatsbyImage
    : isNotMobile
    ? fluid?.gatsbyImage
    : fluid?.mobileImage
    ? fluid?.mobileImage
    : fluid?.gatsbyImage

  const imageProps = {
    className,
    alt,
    objectFit: objectFit || "cover",
    objectPosition: useFocalPoint
      ? `${padX}% ${padY}%`
      : objectPosition || "50% 50%",
    ...restProps,
  }

  const isGif = fluid.fallbackUrl?.includes(".gif")

  const loadingType = isLazyLoading ? "lazy" : "eager"

  return fluid.svg?.content ? (
    <DangerouslySetInnerHtml
      loading={loadingType}
      html={fluid.svg.content}
      element="div"
      className={`gatsby-svg-image ${className}`}
      alt={alt}
      {...svgRest}
    />
  ) : imageToRender?.childImageSharp?.fixed ? (
    <Img
      fixed={imageToRender?.childImageSharp?.fixed}
      loading={loadingType}
      {...imageProps}
    />
  ) : imageToRender?.childImageSharp?.fluid ? (
    <Img
      fluid={imageToRender?.childImageSharp?.fluid}
      loading={loadingType}
      {...imageProps}
    />
  ) : isGif ? (
    <img
      src={fluid.fallbackUrl}
      className={className}
      loading={loadingType}
      alt={alt}
    />
  ) : null
}

export default GatsbyImage
